import React, { useCallback, useState } from 'react';
import styles from './PlannedQuestionnairesWrapper.module.scss';
import QuestionnaireList from '../../../../Components/QuestionnaireList/QuestionnaireList';
import PlannedQuestionnairesFilter, {
	PlannedQuestionnairesFilterValues,
} from './PlannedQuestionnairesFilter/PlannedQuestionnairesFilter';

interface Props {
	patientId?: string;
}

const PlannedQuestionnairesWrapper: React.FC<Props> = ({ patientId }) => {
	const [filter, setFilter] = useState<PlannedQuestionnairesFilterValues>({});
	const [isFilterReady, setIsFilterReady] = useState(false);

	const handleFilterReady = useCallback(() => setIsFilterReady(true), []);

	return (
		<div className={styles.wrapper}>
			<PlannedQuestionnairesFilter
				onFilter={setFilter}
				patientId={patientId}
				onReady={handleFilterReady}
			/>
			<QuestionnaireList
				filter={filter}
				isReady={isFilterReady}
				showPatientName
			/>
		</div>
	);
};

export default PlannedQuestionnairesWrapper;
